import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import {
  GetAllAC_ST_ASD_AwardSourceDropdown,
  GetOneAC_NT_AS_AwardSource,
  setAwardSource,
} from "../../../Redux/Reducers/Submitter/AwardSource";
import { useParams } from "react-router-dom";

function FindOutAward(props) {
  const dispatch = useDispatch();
  const [editValue, setEditValue] = useState(null);
  const [editText, setEditText] = useState(null);
  const [appInfo, setAppInfo] = useState();
  const { ApplicationInformationId } = useParams();
  const AttachmentsAnswerList = useSelector(
    (state) => state.AttachmentsAnswer.ValidationAttachments
  );
  console.log(AttachmentsAnswerList, "AttachmentsAnswerList");

  const lang = useSelector((state) => state.languageReducer.Language);
  const state = useSelector((state) => {
    return {
      FetchDataJson: state.FetchDataJson,
      AwardSourceDropdown: state.AwardSource.AwardSourceDropdown,
      OneAwardSource: state.AwardSource.AwardSource,
    };
  });
  var AttachmentsAnswerListResult =
    AttachmentsAnswerList?.length > 0
      ? AttachmentsAnswerList[0].list.map((x) => x.code)
      : null;
  console.log(AttachmentsAnswerListResult, "sssssssdwwdwd");

  useEffect(() => {
    dispatch(
      GetAllAC_ST_ASD_AwardSourceDropdown({
        isEn: lang === "ar" ? false : true,
      })
    );
  }, [lang]);

  console.log(state.OneAwardSource, "redux");
  console.log(appInfo, "state");
  console.log(state.OneAwardSource?.awardSourceDropdownId, "id");

  const getData = async () => {
    const data = await dispatch(
      GetOneAC_NT_AS_AwardSource({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          ApplicationInformationId,
      })
    );

    if (data.payload) {
      setAppInfo({ ...data.payload });
    }
  };
  useEffect(() => {
    getData();
  }, [ApplicationInformationId]);

  useEffect(() => {
    dispatch(setAwardSource({ ...appInfo }));
  }, [appInfo]);

  return (
    <div className="form-grid" key="find-out-award-form">
      <AllDropDownsAHSF
        fieldsName="HowDidYouFindOutAboutTheAward"
        lang={lang}
        show={true}
        disabled={props.disabled}
        onChange={(e) => {
          setAppInfo({
            ...appInfo,
            awardSourceDropdownId: e.awardSourceDropdownId,
            otherSource: null, // التحديث هنا
          });
        }}
        value={state.OneAwardSource?.awardSourceDropdownId}
        arrayOoptionList={state.AwardSourceDropdown}
        KeyText={lang === "ar" ? "awardSourceNameAr" : "awardSourceNameEn"}
        KeyValue="awardSourceDropdownId"
        yesNo={true}
        valueEdite={appInfo?.awardSourceDropdownId}
        submissionStatus={"edite"}
        textEdite={
          lang !== "ar"
            ? appInfo?.awardSourceNameEn
            : appInfo?.awardSourceNameAr
        }
        id={"awardSourceDropdownId"}
        dropdownType={"search"}
        defaultValue={appInfo?.awardSourceDropdownId}
        OnClickLi={(e) => {
          setAppInfo({
            ...appInfo,
            awardSourceDropdownId: e.awardSourceDropdownId,
            otherSource: null, // التحديث هنا
          });
          setEditValue(e.awardSourceDropdownId);
          setEditText(
            lang === "ar" ? "awardSourceNameAr" : "awardSourceNameEn"
          );
        }}
        showValidationMessage={
          AttachmentsAnswerListResult
            ? AttachmentsAnswerListResult.includes(
                "HowDidYouFindOutAboutTheAward"
              )
            : false
        }
        validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
      />
      <div style={{ marginTop: "5px" }}>
        {appInfo?.awardSourceDropdownId ===
          "2d346678-ba28-4223-9440-409ef21e4784" && (
          <InputAHSF
            fieldsName="PleaseSpecifyHowYouFindOutAboutTheAward"
            lang={lang}
            disabled={props.disabled}
            show={true}
            defaultValue={state.OneAwardSource?.otherSource}
            onChange={(e) => {
              setAppInfo({
                ...appInfo,
                otherSource: e.target.value,
              });
            }}
            showValidationMessage={
              AttachmentsAnswerListResult
                ? AttachmentsAnswerListResult.includes(
                    "PleaseSpecifyHowYouFindOutAboutTheAward"
                  )
                : false
            }
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        )}
      </div>
    </div>
  );
}

export default FindOutAward;
